// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file deeplink/deeplink_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file deeplink/deeplink_model.proto.
 */
export const file_deeplink_deeplink_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1kZWVwbGluay9kZWVwbGlua19tb2RlbC5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3Qi2gIKCERlZXBMaW5rEjEKBHR5cGUYASABKA4yIy5jb20uZ2VtLmJmZi5jb250cmFjdC5EZWVwTGluay5UeXBlEhAKCGVudGl0eUlkGAIgASgJEhUKCHBhcmVudElkGAMgASgJSACIAQESCwoDdXJsGAQgASgJEg0KBWFsaWFzGAUgASgJEg8KB2V4cGlyZWQYBiABKAgSEgoFdGl0bGUYByABKAlIAYgBARIYCgtkZXNjcmlwdGlvbhgIIAEoCUgCiAEBEhUKCGltYWdlVXJsGAkgASgJSAOIAQEiTAoEVHlwZRILCgdVTktOT1dOEAASDwoLQ0hBVF9JTlZJVEUQARIPCgtDQUxMX0lOVklURRACEgsKB01FU1NBR0UQAxIICgRST09NEARCCwoJX3BhcmVudElkQggKBl90aXRsZUIOCgxfZGVzY3JpcHRpb25CCwoJX2ltYWdlVXJsQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.DeepLink
 */
export type DeepLink = Message<'com.gem.bff.contract.DeepLink'> & {
  /**
   * @generated from field: com.gem.bff.contract.DeepLink.Type type = 1;
   */
  type: DeepLink_Type;

  /**
   * @generated from field: string entityId = 2;
   */
  entityId: string;

  /**
   * @generated from field: optional string parentId = 3;
   */
  parentId?: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: string alias = 5;
   */
  alias: string;

  /**
   * @generated from field: bool expired = 6;
   */
  expired: boolean;

  /**
   * @generated from field: optional string title = 7;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string;

  /**
   * @generated from field: optional string imageUrl = 9;
   */
  imageUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.DeepLink.
 * Use `create(DeepLinkSchema)` to create a new message.
 */
export const DeepLinkSchema: GenMessage<DeepLink> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_model, 0);

/**
 * @generated from enum com.gem.bff.contract.DeepLink.Type
 */
export enum DeepLink_Type {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CHAT_INVITE = 1;
   */
  CHAT_INVITE = 1,

  /**
   * @generated from enum value: CALL_INVITE = 2;
   */
  CALL_INVITE = 2,

  /**
   * @generated from enum value: MESSAGE = 3;
   */
  MESSAGE = 3,

  /**
   * @generated from enum value: ROOM = 4;
   */
  ROOM = 4,
}

/**
 * Describes the enum com.gem.bff.contract.DeepLink.Type.
 */
export const DeepLink_TypeSchema: GenEnum<DeepLink_Type> =
  /*@__PURE__*/
  enumDesc(file_deeplink_deeplink_model, 0, 0);
